// Internal desks, in handoff order. The sidebar and the guide both read this.

import premiumInvoice from "../../assets/finance-guide/premium-invoice.png";
import claimsFunding from "../../assets/finance-guide/claims-funding.png";
import homeAccount from "../../assets/home-guide/home-account.png";
import homeStopLoss from "../../assets/home-guide/home-stoploss.png";
import visitPlan from "../../assets/provider-guide/visit-plan.png";
import claimSubmit from "../../assets/claims-guide/claim-submit.png";

export const ADMIN_DESK = {
    id: "admin",
    label: "Admin",
    to: "/internal/admin",
    kicker: "Account",
    name: "The whole account",
    detail: "Every desk works from this account. Each team’s form comes later.",
    writes: "The full account. Team forms will land here, one desk at a time.",
    img: homeAccount,
    alt: "An employer and a plan folder",
};

export const INTERNAL_DESKS = [
    {
        id: "underwriter",
        label: "Underwriter",
        to: "/internal/underwriter",
        kicker: "Quote",
        name: "Rates and stop-loss",
        detail: "ASO and level-funded rates, and the stop-loss quote.",
        writes: "Quoted rates and stop-loss. Nothing is signed yet.",
        img: homeStopLoss,
        alt: "An umbrella over a group of claims",
    },
    {
        id: "proposal",
        label: "Proposal generator",
        to: "/internal/proposal",
        kicker: "Offer",
        name: "Current plan next to Centivo",
        detail: "The comparison the employer sees, with expected savings.",
        writes: "The proposal, expected enrollments, and savings. Rates and stop-loss stay the underwriter’s numbers.",
        img: premiumInvoice,
        alt: "A premium invoice",
    },
    {
        id: "sales",
        label: "Sales",
        to: "/internal/sales",
        kicker: "Plan",
        name: "The benefit plan they bought",
        detail: "Deductible, copays, Rx tiers, and which services are covered.",
        writes: "The benefit plan, service by service. Not the CPT, HCPCS, or revenue codes.",
        img: homeAccount,
        alt: "An employer and a plan folder",
    },
    {
        id: "client-success",
        label: "Client success",
        to: "/internal/client-success",
        kicker: "Go-live",
        name: "Who runs the account",
        detail: "Contacts, address, telemedicine, and utilization management.",
        writes: "Contacts, address, and the vendors on the account.",
        img: claimsFunding,
        alt: "A claim and a money bag",
    },
    {
        id: "legal",
        label: "Legal",
        to: "/internal/legal",
        kicker: "Signed",
        name: "The stop-loss after signature",
        detail: "The quoted stop-loss, copied onto the account once it is signed.",
        writes: "The signed stop-loss. It copies the proposal; it does not re-quote it.",
        img: claimSubmit,
        alt: "A document ready to send",
    },
    {
        id: "plan-config",
        label: "Plan config",
        to: "/internal/plan-config",
        kicker: "Build",
        name: "Services become codes",
        detail: "Each covered service gets CPT, HCPCS, and revenue codes.",
        writes: "The codes on each service. The benefit plan already says what is covered.",
        img: visitPlan,
        alt: "Plan pieces",
    },
];

export const findInternalDesk = (id) => (
    id === ADMIN_DESK.id ? ADMIN_DESK : INTERNAL_DESKS.find((desk) => desk.id === id)
);

export const INTERNAL_NAV = [
    { id: "guide", label: "Guide", to: "/internal/guide" },
    { id: "services", label: "Services", to: "/internal/services" },
    { id: ADMIN_DESK.id, label: ADMIN_DESK.label, to: ADMIN_DESK.to },
    ...INTERNAL_DESKS.map(({ id, label, to }) => ({ id, label, to })),
    { id: "poc", label: "POC", to: "/internal/poc" },
];
